import React from 'react';
import './App.css';
import Navigation from './components/Navigation';
import HeroNew from './components/HeroNew';
import ExperienceNew from './components/ExperienceNew';
import SkillsNew from './components/SkillsNew';
import EducationNew from './components/EducationNew';
import CreationsLearnings from './components/CreationsLearnings';
import ContactNew from './components/ContactNew';
import FooterNew from './components/FooterNew';

function App() {
  return (
    <div className="App bg-[#f5f0e6] min-h-screen">
      <Navigation />
      <HeroNew />
      <CreationsLearnings />
      <ExperienceNew />
      <SkillsNew />
      <EducationNew />
      <ContactNew />
      <FooterNew />
    </div>
  );
}

export default App;
